<template>
        <div class="crumb">
            <span>数据中心</span> 
        </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .crumb{
        width: 1200px;
        height: 22px;
        margin: 24px auto;
        font-size: 16px;
        color: rgba(153, 153, 153, 1)
    }
</style>